<div class="link-component">
  <div id="upload-container" [class.active]="dropZoneActive()">
    <img class="image" src="../../../../../images/cloud-2044823_960_720.png" alt="Upload icon" />
    <p class="text">Drag and drop file here; or click to browse...</p>
  </div>
  <dx-file-uploader [visible]="false" dropZone="#upload-container" dialogTrigger="#upload-container" uploadMode="useButtons" [multiple]="false" [allowedFileExtensions]="allowedFileExtensions()"
    [maxFileSize]="maxFileSize()" (onValueChanged)="onValueChanged($event)" (onDropZoneEnter)="onDropZoneEnter($event)" (onDropZoneLeave)="onDropZoneLeave($event)">
  </dx-file-uploader>
</div>

